// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Ii9g","signatureBlock":"Footer_signatureBlock__3rgmv","signature":"Footer_signature__1D2G4"};